import { Button, Card, CardBody, CardHeader, Center, Container, FormControl, Grid, Heading, Stack } from '@chakra-ui/react';
import { Input } from '@chakra-ui/react'

const UserForm = ({ user }: any) => {

    return (
        <Grid minHeight="100vh">
            <Center>
                <Container>
                    <Card>
                        <CardHeader>
                            <Heading size='md'>
                                <Center>
                                    Crear usuario
                                </Center>
                            </Heading>
                        </CardHeader>
                        <CardBody>
                            <Stack spacing={3}>
                                <form>
                                    <FormControl>
                                        <Input placeholder='Correo electronico'/>
                                        <Input placeholder='Clave'/>
                                        <Input placeholder='Nombre completo'/>
                                        <Button colorScheme='teal' variant='outline' type='submit'>Registrar</Button>
                                    </FormControl>
                                </form>
                            </Stack>
                        </CardBody>
                    </Card>
                </Container>
            </Center>
        </Grid>
    );
}

export default UserForm;
